/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import Footer from './Footer';
import './generalPages.css'

const ReleaseNotes = props => {

    // contexts
    const { theme, fontWeight } = useContext(ThemeContext);

    // states
    const [isOpen, setIsOpen] = useState([
        false, false, false, false, false,
        false, false, false, false, false,
        false, false, false, false, false,
        false, false, false, false, false,
        false, false, false, false, false
    ]);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // utility functions
    const toggle = (index) => {
        try {
            setIsOpen({ ...isOpen, [index]: !isOpen[index] })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General ReleaseNotes toggle', 'Error in try catch block', err.stack);
        }
    };

    // function's return
    return (
        <div className="ReleaseNotesMainDiv">
            <ErrorBoundary errorAt="At General ReleaseNotes GeneralNavbar">
                <GeneralNavbar history={props.history} isReleaseNotesPage={true} />
            </ErrorBoundary>
            <div id="release-notes-heading" className="custom-header">
                <h3 id="release-notes-heading">Release Notes</h3>
            </div>
            <div className="p-3 m-3" style={theme.card} id="2.3.0">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(22)}>
                    <span style={theme.headingBold}>2.4.0</span>
                    {
                        isOpen[22]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[22]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                    <div style={{ fontWeight: fontWeight.medium }}>Released on March 22, 2024</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added new feature where user can select for whom to book session.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>SEO improvements for counsellor public profiles.</li>
                            <li>Performance improvements.</li>
                            <li>Bug fixes.</li>
                        </ul>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="2.3.0">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(21)}>
                    <span style={theme.headingBold}>2.3.0</span>
                    {
                        isOpen[21]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[21]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                    <div style={{ fontWeight: fontWeight.medium }}>Released on July 27, 2023</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added features page where user can see all featues of Umang Wellness.</li>
                            <li>Added features to invite new counsellor with a custom QR code on it.</li>
                            <li>Counsellors will be able to share dailyfeed to thier social media accounts directly from Umang Wellness.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>UI improvements.</li>
                            <li>Bug fixes.</li>
                        </ul>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="2.2.1">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(20)}>
                    <span style={theme.headingBold}>2.2.1</span>
                    {
                        isOpen[20]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[20]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on May 22, 2023</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                        </ul>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="2.2.0">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(19)}>
                    <span style={theme.headingBold}>2.2.0</span>
                    {
                        isOpen[19]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[19]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on March 20, 2023</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                            <li>UI improvements.</li>
                        </ul>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="2.1.2">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(18)}>
                    <span style={theme.headingBold}>2.1.2</span>
                    {
                        isOpen[18]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[18]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on February 10, 2023</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                        </ul>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="2.1.1">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(17)}>
                    <span style={theme.headingBold}>2.1.1</span>
                    {
                        isOpen[17]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[17]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on February 01, 2023</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="2.1.0">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(16)}>
                    <span style={theme.headingBold}>2.1.0</span>
                    {
                        isOpen[16]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[16]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on January 12, 2023</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added new Loading screen with life quotes.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="2.0.1">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(15)}>
                    <span style={theme.headingBold}>2.0.1</span>
                    {
                        isOpen[15]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[15]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on October 10, 2022</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Daily feed bug fixed.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="2.0.0">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(14)}>
                    <span style={theme.headingBold}>2.0.0</span>
                    {
                        isOpen[14]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[14]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on October 5, 2022</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added subscriptions for users where they can subscribe to their selected counsellor.</li>
                            <li>Added live text message chat where user can chat with selected counsellor.</li>
                            <li>Added public profile pages for counsellors with their personalised url.</li>
                            <li>Counsellor will be able to create custom subscription plans to which their clients can subscribe.</li>
                            <li>Added subscriptions for counsellors.</li>
                            <li>Added feature where new counsellors can claim their profile from unverified counsellors list and manage it.</li>
                            <li>Added services section where all services provided by Umang Wellness will be displayed.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>New improved signup flow for all users.</li>
                            <li>Demo users will be able to signin directly to their demo account after signup.</li>
                            <li>Increased size of otp for extra security.</li>
                            <li>Bug fixes.</li>
                            <li>UI improvements.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.13">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(13)}>
                    <span style={theme.headingBold}>1.1.13</span>
                    {
                        isOpen[13]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[13]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on May 13, 2022</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                            <li>UI improvements.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.12">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(12)}>
                    <span style={theme.headingBold}>1.1.12</span>
                    {
                        isOpen[12]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[12]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on January 9, 2022</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Counsellor can now book session for their clients directly.</li>
                            <li>Added In-Person option for session booking.</li>
                            <li>Added Timezone update option to change timezone of website.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>UI improvements.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.11">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(11)}>
                    <span style={theme.headingBold}>1.1.11</span>
                    {
                        isOpen[11]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[11]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on July 19, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added new Error report form.</li>
                            <li>Added auto update popup.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Bug fixes.</li>
                            <li>UI improvements.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.10">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(10)}>
                    <span style={theme.headingBold}>1.1.10</span>
                    {
                        isOpen[10]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[10]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on June 11, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added In-app Notifications feature.</li>
                            <li>User can change password from settings.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Replaced "Login" with "SignIn" and "Register" with "SignUp".</li>
                            <li>UI improvements.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.9">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(9)}>
                    <span style={theme.headingBold}>1.1.9</span>
                    {
                        isOpen[9]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[9]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on March 18, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added PWA support.</li>
                            <li>Added Google Single Sign On.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <ul>
                            <li>Fixed issue occured while loading counsellor list.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Auto fill email while going to forgot password.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.8">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(8)}>
                    <span style={theme.headingBold}>1.1.8</span>
                    {
                        isOpen[8]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[8]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on March 12, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added demo feature for user so that they can experience app before sign up.</li>
                            <li>Added invite button to invite new clients for counsellor.</li>
                            <li>Added feature where client will be able to recommend their counsellor to other users.</li>
                            <li>Added feature where admin will be able to send customized email to users from admin panel.</li>
                            <li>Added walkthrough for users which will guide them on how to use site.</li>
                            <li>Added breakdown for payment details as per sessions for counsellors.</li>
                            <li>Added pdf report for payment details.</li>
                            <li>Added feature to let user know if they lost their internet connectivity.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <ul>
                            <li>Removed deprecated code of moment library.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Changed logic for calculating discounts.</li>
                            <li>Counsellor will be able to add multiple timeslots for a day.</li>
                            <li>Going back from "Make Payment" page will retain selection at "Book session" page.</li>
                            <li>Added reminder for users to save changes before they leave the perticular page.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.7">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(7)}>
                    <span style={theme.headingBold}>1.1.7</span>
                    {
                        isOpen[7]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[7]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on January 25, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added guide for counsellor on uploading a perfect profile photo.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <ul>
                            <li>Counsellor will not show up in counsellor list unless they complete their profile.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Added client's name at top of their form responses for better UX.</li>
                            <li>App will collect and identify cities, languages and specialities of existing counsellor to add it as filter at counsellor list page.</li>
                        </ul>
                    </div >
                </Collapse >
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.6">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(6)}>
                    <span style={theme.headingBold}>1.1.6</span>
                    {
                        isOpen[6]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[6]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on January 19, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Counsellor will be able to see email and phone of client in session detail itself.</li>
                            <li>Cursor will automatically move to OTP field once it is requested.</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.5">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(5)}>
                    <span style={theme.headingBold}>1.1.5</span>
                    {
                        isOpen[5]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[5]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on January 06, 2021</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>New counsellor sign up request will automatically appear at admin panel.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <ul>
                            <li>Fixed issue where counsellor was able to request for sign up multiple times.</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Changed email text to make it more user friendly ("navbar" to "counsellor dashboard")</li>
                            <li>Added link to sign in page in welcome email for counsellor.</li>
                            <li>Added confirmation popup at admin panel while activating/deactivating a user.</li>
                        </ul>
                    </div >
                </Collapse >
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.4">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(4)}>
                    <span style={theme.headingBold}>1.1.4</span>
                    {
                        isOpen[4]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[4]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on December 13, 2020</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added reminder emails for selecting counsellor and booking a free session</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.3">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(3)}>
                    <span style={theme.headingBold}>1.1.3</span>
                    {
                        isOpen[3]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[3]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on December 09, 2020</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>Added effective date to cookie policy</li>
                        </ul>
                    </div>
                </Collapse>
            </div >
            <div className="p-3 m-3" style={theme.card} id="1.1.2">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(2)}>
                    <span style={theme.headingBold}>1.1.2</span>
                    {
                        isOpen[2]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[2]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on December 07, 2020</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added error log for client and server side</li>
                            <li>Added RSS Feed</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="1.1.1">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(1)}>
                    <span style={theme.headingBold}>1.1.1</span>
                    {
                        isOpen[1]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[1]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on November 27, 2020</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <ul>
                            <li>Added forms feature</li>
                            <li>Added gift vouchers</li>
                        </ul>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                        <ul>
                            <li>UI changes</li>
                            <li>UI changes for mobile view</li>
                            <li>Added social media link to footer</li>
                            <li>Prevent user from booking session before completing profile</li>
                        </ul>
                    </div>
                </Collapse>
            </div>
            <div className="p-3 m-3" style={theme.card} id="1.1.0">
                <div className="row px-3" style={{ cursor: "pointer" }} onClick={() => toggle(0)}>
                    <span style={theme.headingBold}>1.1.0</span>
                    {
                        isOpen[0]
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                    }

                </div>

                <Collapse isOpen={isOpen[0]}>
                    <hr />
                    <div className="my-auto" style={theme.paragraph}>
                        <div style={{ fontWeight: fontWeight.medium }}>Released on November 12, 2020</div>
                        <div style={{ fontWeight: fontWeight.medium }}>New features</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Fixes</div>
                        <div style={{ fontWeight: fontWeight.medium }}>Improvements</div>
                    </div>
                </Collapse>
            </div>
            <Footer />
        </div >
    )

}

export default ReleaseNotes;